import { ComponentProps, ReactNode } from 'react';
import styles from './styles.module.scss';

type Props = {
  children: ReactNode;
  onSearch: ComponentProps<'button'>['onClick'];
  onClear: ComponentProps<'button'>['onClick'];
  searchButtonText?: string;
  clearButtonText?: string;
};

export const TableSearch: React.FC<Props> = ({
  children,
  onSearch,
  onClear,
  searchButtonText = '検索する',
  clearButtonText = '条件をクリア',
}) => (
  <div className={styles.TableSearch}>
    <div>{children}</div>
    <div className={styles.TableSearch__SearchContainer}>
      <button
        type='button'
        className={styles.TableSearch__SearchContainer__SearchButton}
        onClick={onSearch}
      >
        {searchButtonText}
      </button>
      <button
        type='button'
        className={styles.TableSearch__SearchContainer__ClearButton}
        onClick={onClear}
      >
        {clearButtonText}
      </button>
    </div>
  </div>
);
